import jpFonts from "./subsetJPFont/subsetText";

if (process.env.GATSBY_LANG === "ja") {
  const addScript = (src: string) => {
    const head = document.head;
    const script = document.createElement("script");
    script.src = src;
    head.appendChild(script);
  };
  addScript(
    "https://webfont.fontplus.jp/accessor/script/fontplus.js?dUOM7ZCrAGA%3D&box=7xe-5KpHyq8%3D&aa=1&ab=2"
  );
  window.addEventListener("load", () => {
    // Font Plusをロード
    window.FONTPLUS.async();
    window.FONTPLUS.load(
      [
        {
          fontname: "TazuganeGothicStdN-Regular",
          nickname: "TazuganeGothicStdN-Regular",
          text: jpFonts,
        },
        {
          fontname: "TazuganeGothicStdN-Medium",
          nickname: "TazuganeGothicStdN-Medium",
          text: jpFonts,
        },
        {
          fontname: "TazuganeGothicStdN-Light",
          nickname: "TazuganeGothicStdN-Light",
          text: jpFonts,
        },
      ],
      null,
      null
    );
    // window.FONTPLUS.reload(false);
  });
}

const setBodyGtm = () => {
  const body = document.body;
  const noScript = `<!-- Google Tag Manager (noscript) --><noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P7G87DT"height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><!-- End Google Tag Manager (noscript) -->`;
  body.insertAdjacentHTML("afterbegin", noScript);
};

setBodyGtm();
